<div class="welcome-canvas">
    <div class="welcome-content">
        @if (level() !== 'root') {
            <span class="welcome-hero">
                <ra-icon icon="document-normal" varColor="primary" [size]="30" />
            </span>
        }

        @if (level() === 'root') {
            <div class="welcome-step" animate.enter="step-enter-back">
                <h2 class="welcome-title">{{ 'order.welcome.title' | translate }}</h2>
                <p class="welcome-subtitle">{{ 'order.welcome.subtitle' | translate }}</p>

                <div class="welcome-cards">
                    <button type="button" class="welcome-card" (click)="newService()">
                        <span class="welcome-card__badge">{{ 'order.welcome.recommended' | translate }}</span>
                        <span class="welcome-card__figure welcome-card__figure--service">
                            <ra-icon icon="folder" varColor="primary" [size]="40" />
                        </span>
                        <span class="welcome-card__texts">
                            <strong>{{ 'order.feed.newService' | translate }}</strong>
                            <small>{{ 'order.welcome.serviceHint' | translate }}</small>
                        </span>
                        <span class="welcome-card__cta welcome-card__cta--primary">
                            {{ 'order.welcome.serviceCta' | translate }}
                        </span>
                    </button>

                    <button type="button" class="welcome-card" (click)="level.set('document')">
                        <span class="welcome-card__figure welcome-card__figure--document">
                            <ra-icon icon="file" varColor="contentSecondary" [size]="40" />
                        </span>
                        <span class="welcome-card__texts">
                            <strong>{{ 'order.feed.newDocument' | translate }}</strong>
                            <small>{{ 'order.welcome.documentHint' | translate }}</small>
                        </span>
                        <span class="welcome-card__cta welcome-card__cta--tonal">
                            {{ 'order.welcome.documentCta' | translate }}
                        </span>
                    </button>
                </div>

                <!-- Mini-guia do fluxo: cria → preenche → gera o PDF -->
                <div class="welcome-steps">
                    <div class="welcome-guide-step welcome-guide-step--active">
                        <span class="welcome-guide-step__num">1</span>
                        <span class="welcome-guide-step__texts">
                            <b>{{ 'order.welcome.step1Title' | translate }}</b>
                            <small>{{ 'order.welcome.step1Hint' | translate }}</small>
                        </span>
                    </div>
                    <div class="welcome-guide-step">
                        <span class="welcome-guide-step__num">2</span>
                        <span class="welcome-guide-step__texts">
                            <b>{{ 'order.welcome.step2Title' | translate }}</b>
                            <small>{{ 'order.welcome.step2Hint' | translate }}</small>
                        </span>
                    </div>
                    <div class="welcome-guide-step">
                        <span class="welcome-guide-step__num">3</span>
                        <span class="welcome-guide-step__texts">
                            <b>{{ 'order.welcome.step3Title' | translate }}</b>
                            <small>{{ 'order.welcome.step3Hint' | translate }}</small>
                        </span>
                    </div>
                </div>

                <!-- Conta pode estar "vazia" só porque arquivou/removeu tudo -->
                <div class="welcome-utilities">
                    <button type="button" (click)="isArchivedPanelVisible.set(true)">
                        <ra-icon icon="archive" varColor="currentColor" [size]="16" />
                        {{ 'order.status.archived' | translate }}
                    </button>
                    <button type="button" (click)="isTrashPanelVisible.set(true)">
                        <ra-icon icon="trash" varColor="currentColor" [size]="16" />
                        {{ 'order.trashPanel.title' | translate }}
                    </button>
                </div>
            </div>
        }
        @else if (level() === 'document-type') {
            <!-- Passo 3: o tipo. Sem serviço não há cliente, então contrato e
                 orçamento nascem sem o signatário do cliente. -->
            <div class="welcome-step" animate.enter="step-enter-forward">
                <h2 class="welcome-title">{{ 'order.feed.chooseType' | translate }}</h2>
                <p class="welcome-subtitle">{{ 'order.feed.chooseTypeSubtitle' | translate }}</p>

                <div class="welcome-options">
                    <button type="button" class="welcome-option" (click)="newStandaloneDocument(documentTypeEnum.NORMAL)">
                        <span class="welcome-option__icon welcome-option__icon--report">
                            <ra-icon icon="document-normal" varColor="primary" [size]="22" />
                        </span>
                        <span class="welcome-option__texts">
                            <strong>{{ 'order.feed.typeReport' | translate }}</strong>
                            <small>{{ 'order.documentOptions.blankDocumentDescription' | translate }}</small>
                        </span>
                        <ra-icon icon="arrow-right" varColor="contentTertiary" [size]="18" />
                    </button>

                    <button type="button" class="welcome-option" (click)="newStandaloneDocument(documentTypeEnum.CONTRACT)">
                        <span class="welcome-option__icon welcome-option__icon--contract">
                            <ra-icon icon="pen-draw" varColor="accentGreen" [size]="22" />
                        </span>
                        <span class="welcome-option__texts">
                            <strong>{{ 'order.documentOptions.contract' | translate }}</strong>
                            <small>{{ 'order.documentOptions.contractDescription' | translate }}</small>
                        </span>
                        <ra-icon icon="arrow-right" varColor="contentTertiary" [size]="18" />
                    </button>

                    <button type="button" class="welcome-option" (click)="newStandaloneDocument(documentTypeEnum.QUOTE)">
                        <span class="welcome-option__icon welcome-option__icon--quote">
                            <ra-icon icon="dollar-circle" varColor="accentOrange" [size]="22" />
                        </span>
                        <span class="welcome-option__texts">
                            <strong>{{ 'order.documentOptions.quote' | translate }}</strong>
                            <small>{{ 'order.documentOptions.quoteDescription' | translate }}</small>
                        </span>
                        <ra-icon icon="arrow-right" varColor="contentTertiary" [size]="18" />
                    </button>
                </div>

                <div class="welcome-actions">
                    <ra-button
                        [id]="'button-back-welcome-type'"
                        [label]="'order.common.back' | translate"
                        [type]="'primary-outline'"
                        (click)="level.set('document')"
                    />
                </div>
            </div>
        }
        @else {
            <div class="welcome-step" animate.enter="step-enter-forward">
                <h2 class="welcome-title">{{ 'order.feed.newDocument' | translate }}</h2>
                <p class="welcome-subtitle">{{ 'order.welcome.documentSubtitle' | translate }}</p>

                <div class="welcome-options">
                    <!-- Ordem do feed-list: caminhos assistidos primeiro, manual por último -->
                    @if (!featureFlagController.isBlocked('generate_with_ia')) {
                        <button type="button" class="welcome-option" (click)="newDocumentByChat()">
                            <span class="welcome-option__icon welcome-option__icon--chat">
                                <ra-icon icon="magicpen" varColor="primary" [size]="22" />
                            </span>
                            <span class="welcome-option__texts">
                                <strong>{{ 'order.feed.useChat' | translate }}</strong>
                                <small>{{ 'order.feed.useChatHint' | translate }}</small>
                            </span>
                            <ra-icon icon="arrow-right" varColor="contentTertiary" [size]="18" />
                        </button>
                    }

                    @if (!featureFlagController.isBlocked('import_files')) {
                        <button type="button" class="welcome-option" (click)="newDocumentByImport()">
                            <span class="welcome-option__icon welcome-option__icon--import">
                                <ra-icon icon="document-upload" varColor="accentOrange" [size]="22" />
                            </span>
                            <span class="welcome-option__texts">
                                <strong>{{ 'order.feed.importFiles' | translate }}</strong>
                                <small>{{ 'order.feed.importFilesHint' | translate }}</small>
                            </span>
                            <ra-icon icon="arrow-right" varColor="contentTertiary" [size]="18" />
                        </button>
                    }

                    <button type="button" class="welcome-option" (click)="level.set('document-type')">
                        <span class="welcome-option__icon welcome-option__icon--document">
                            <ra-icon icon="document-normal" varColor="primary" [size]="22" />
                        </span>
                        <span class="welcome-option__texts">
                            <strong>{{ 'order.feed.createManually' | translate }}</strong>
                            <small>{{ 'order.feed.createManuallyHint' | translate }}</small>
                        </span>
                        <ra-icon icon="arrow-right" varColor="contentTertiary" [size]="18" />
                    </button>
                </div>

                <div class="welcome-actions">
                    <ra-button
                        [id]="'button-back-welcome'"
                        [label]="'order.common.back' | translate"
                        [type]="'primary-outline'"
                        (click)="level.set('root')"
                    />
                </div>
            </div>
        }
    </div>
</div>

@if (isModalCreateOrderVisible()) {
    <order-create
        (close)="isModalCreateOrderVisible.set(false)"
        (created)="orderCreated($event)"
    />
}

@if (isImportDocumentsVisible()) {
    <!-- orderId null = documento AVULSO (o backend cria a order pessoal) -->
    <import-documents-modal
        [orderId]="null"
        (created)="onImportCreated()"
        (close)="isImportDocumentsVisible.set(false)"
    />
}

@if (isArchivedPanelVisible()) {
    <order-archived-panel [feedMode]="true" (close)="onArchivedClosed()" />
}

@if (isTrashPanelVisible()) {
    <order-trash-panel (close)="onTrashClosed()" />
}
